<script lang="ts">
import {defineComponent, ref, watch} from 'vue';
import {getAddress} from '../js/get_address';
import {useGlobalStore} from "../stores/global";

export default defineComponent({
  name: 'Address',
  props: {
    trans: { type: Object, required: true },
    validation_run: { type: Boolean, default: false },
    postcode: { type: String, default: '' },
    number: { type: String, default: '' },
    street: { type: String, default: '' },
    town: { type: String, default: '' },
  },
  emits: [
    'update:postcode',
    'update:number',
    'update:street',
    'update:town'
  ],
  setup(props, {emit}) {
    const loading = ref(false);
    const localPostcode = ref(props.postcode);
    const localNumber = ref(props.number);
    const localStreet = ref(props.street);
    const localTown = ref(props.town);

    watch(localPostcode, (newVal) => emit('update:postcode', newVal));
    watch(localNumber, (newVal) => emit('update:number', newVal));
    watch(localStreet, (newVal) => emit('update:street', newVal));
    watch(localTown, (newVal) => emit('update:town', newVal));

    const store = useGlobalStore();
    const useAutocomplete = (store.webspace === 'btknl');

    const handleGetAddress = async () => {
      if (!useAutocomplete) {
        return;
      }

      loading.value = true;
      const result = await getAddress(localPostcode.value, localNumber.value);
      localStreet.value = result.street;
      localTown.value = result.town;
      loading.value = false;
    };

    return {
      localPostcode,
      localNumber,
      localStreet,
      localTown,
      handleGetAddress,
      loading,
      useAutocomplete
    };
  },
});
</script>

<template>
  <template v-if="useAutocomplete">
    <div class="row">
      <div>
        <label for="reaction-form-postcode">
          {{ trans.postcode }}
        </label>
        <span class="tooltip">
          <span class="icon-info"></span>
          <div class="tooltip-content">
              <h4>{{ trans.autocomplete_title }}</h4>
              <p>{{ trans.autocomplete_content }}</p>
          </div>
        </span>
        <input v-model="localPostcode" @change="handleGetAddress" id="reaction-form-postcode" type="text" placeholder=""
               :class="{'p-invalid': validation_run && !localPostcode}" required>
      </div>
      <div>
        <label for="reaction-form-number">{{ trans.house_number }}</label>
        <input v-model="localNumber" @change="handleGetAddress" id="reaction-form-number" type="text" placeholder=""
               :class="{'p-invalid': validation_run && !localNumber}" required>
      </div>
    </div>

    <div class="row">
      <div>
        <label for="reaction-form-street">{{ trans.street }}</label>
        <div :class="{ 'loading': loading }">
          <input v-model="localStreet" id="reaction-form-street" type="text" placeholder="" :class="{'p-invalid': validation_run && !localStreet}" required/>
        </div>
      </div>
      <div>
        <label for="reaction-form-town">{{ trans.town }}</label>
        <div :class="{ 'loading': loading }">
          <input v-model="localTown" id="reaction-form-town" type="text" placeholder="" :class="{'p-invalid': validation_run && !localTown}" required/>
        </div>
      </div>
    </div>
  </template>

  <template v-else>
    <div class="row">
      <div>
        <label for="reaction-form-street">{{ trans.street }}</label>
        <div :class="{ 'loading': loading }">
          <input v-model="localStreet" id="reaction-form-street" type="text" placeholder="" :class="{'p-invalid': validation_run && !localStreet}" required/>
        </div>
      </div>
      <div>
        <label for="reaction-form-town">{{ trans.town }}</label>
        <div :class="{ 'loading': loading }">
          <input v-model="localTown" id="reaction-form-town" type="text" placeholder="" :class="{'p-invalid': validation_run && !localTown}" required/>
        </div>
      </div>
    </div>

    <div class="row">
      <div>
        <label for="reaction-form-postcode">{{ trans.postcode }}</label>
        <input v-model="localPostcode" id="reaction-form-postcode" type="text" placeholder="" :class="{'p-invalid': validation_run && !localPostcode}" required>
      </div>
      <div>
        <label for="reaction-form-number">{{ trans.house_number }}</label>
        <input v-model="localNumber" id="reaction-form-number" type="text" placeholder="" :class="{'p-invalid': validation_run && !localNumber}" required>
      </div>
    </div>
  </template>
</template>